// extracted by mini-css-extract-plugin
module.exports = {"TableOfContentsTitle":"styles_TableOfContentsTitle__ShX7v","archiveLink":"styles_archiveLink__EqjQ_"};